// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_1MIZ7lfo_yJ8QzNDAEhkl4","layout":"_34LV_JDbHVggn79GaA23FL","content":"_3jdt77IDwpwnDFRufeOQs0"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/AccountLayout/styles.scss
// module id = 633
// module chunks = 11